import axios from "axios";

const normalizeBaseUrl = (value = "") => value.replace(/\/+$/, "");
let onUnauthorized = null;

const apiClient = axios.create({
  baseURL: normalizeBaseUrl(process.env.REACT_APP_BASE_URL),
  headers: {
    Accept: "application/json",
  },
});

const fallbackMessages = {
  401: "Unauthenticated.",
  404: "Not Found",
  422: "The given data was invalid.",
  500: "Server Error",
};

export const normalizeApiError = (error) => {
  const status = error?.response?.status ?? 500;
  const data = error?.response?.data ?? {};

  return {
    status,
    message:
      data.message ??
      fallbackMessages[status] ??
      "Ocurrio un error inesperado.",
    errors:
      data.errors && typeof data.errors === "object" ? data.errors : undefined,
  };
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const normalizedError = normalizeApiError(error);

    if (normalizedError.status === 401 && typeof onUnauthorized === "function") {
      onUnauthorized(normalizedError);
    }

    return Promise.reject(normalizedError);
  }
);

export const setAuthToken = (token) => {
  if (token) {
    apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
    return;
  }

  delete apiClient.defaults.headers.common.Authorization;
};

export const registerUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

export default apiClient;
